export default __webpack_public_path__ + "static/media/meteorlog.a5e867c7.jpeg";